// 导入样式文件
import './VoiceHeader.less';
import create from '@/assets/layouts/dashboard/create.svg';
import excess from '@/assets/layouts/dashboard/excess.svg';
import { useDrawer } from '@/hooks/DrawerHooks';
// 导入React hooks
import { useEffect } from 'react';
// 导入自定义Icon组件
// import Icon from '@/components/iconfont/Icon.jsx';
// 导入仪表板数据hook
import { useDashboardData } from '@/hooks/DashboardHooks';
import { useContext } from 'react';
import AivoiceContext from '@/context/AiVoiceContext';
// import SentryTracker from '@/utils/Sentry/sentryUtils';
import { useTranslation } from 'react-i18next';
export default function VoiceHeader() {
  const { setIsOpen } = useDrawer();
  const { t } = useTranslation();
  // 获取用户数据和更新回调
  const { userData, needShowUploadVoice, setNeedShowUploadVoice } = useDashboardData();
  const { setShowNotification, voiceList } = useContext(AivoiceContext);
  useEffect(() => {
    if (!needShowUploadVoice) return;
    handleCreate();
    setNeedShowUploadVoice(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needShowUploadVoice]);
  const handleCreate = () => {
    // SentryTracker.captureEvent('voicepage_create_voice_click', userData?.userInfo?.email);

    window.onClickGATrackEvent('new-voice-create');
    if (voiceList.length >= userData?.userSubscription?.voiceCountQuota) {
      setIsOpen(true);
    } else {
      setShowNotification(true);
    }
  };
  return (
    <div className="voiceheader_box">
      <div className="voiceheader_text">
        <div className="text">
          {/* My voices */}
          {t('As_AIVoice_My')}
        </div>
        <div
          className={`badge  voices_num ${voiceList.length >= userData?.userSubscription?.voiceCountQuota ? 'badge-error' : 'badge-accent'}`}>
          {voiceList.length}/{userData?.userSubscription?.voiceCountQuota}
        </div>
      </div>
      {userData?.userSubscription?.voiceCount >= 20 ? (
        <div className="voiceheader_text">
          {/* You have reached the limit of voice clones */}
          {t('As_VoiceManage_UsageMax')}
        </div>
      ) : (
        <button className="btn btn-primary btn-sm create_btn" onClick={handleCreate}>
          <img
            src={voiceList.length >= userData?.userSubscription?.voiceCountQuota ? excess : create}
            alt=""
          />
          {/* Create New Voice */}
          {t('As_CreateVoice_P1Title')}
        </button>
      )}
    </div>
  );
}
